/**
 * @return number
 */
function getOneDay() {
    return 24 * 60 * 60 * 1000;
}
/**
 * @param {Date} date
 * @return number
 */
export function daysInYear(date) {
    return date.getFullYear() % 4 == 0 ? 366 : 365;
}
/**
 * @param {Date} date
 * @param {number} month
 * @return number
 */
export function daysInMonths(date, month) {
    var dateClone = new Date(date.getTime());
    dateClone.setMonth(dateClone.getMonth() + month);
    return Math.round((dateClone.getTime() - date.getTime()) / getOneDay());
}
